import "./AppHeader.css";
import { APP_CONFIG } from "../../utils/constants.js";
import SettingsDropdown from "../SettingsDropdown/SettingsDropdown.js";

class AppHeader {
  constructor() {
    this.onHistoryClick = null; // Callback pour ouvrir l'historique
    this.settingsDropdown = null;
  }

  setHistoryClickHandler(callback) {
    this.onHistoryClick = callback;
  }

  mount(selector) {
    const container = document.querySelector(selector);
    if (!container) {
      throw new Error(`Container not found: ${selector}`);
    }

    container.innerHTML = `
      <header class="header">
        <h1 class="header__title">
          🔍 ${APP_CONFIG.name}
        </h1>
        <div class="header__actions">
          <button id="settings-btn" class="btn-settings" title="Configuration">
            ⚙️
          </button>
          <button id="history-btn" class="btn-history" title="Historique des messages">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"/>
            </svg>
          </button>
        </div>
      </header>
      <div id="settings-dropdown-mount"></div>
    `;

    this.bindEvents();
  }

  bindEvents() {
    const historyBtn = document.getElementById("history-btn");
    if (historyBtn) {
      historyBtn.addEventListener("click", () => {
        if (this.onHistoryClick) {
          this.onHistoryClick();
        }
      });
    }

    const settingsBtn = document.getElementById("settings-btn");
    if (settingsBtn) {
      settingsBtn.addEventListener("click", () => this.toggleSettings());
    }
  }

  /**
   * Ouvre/ferme le dropdown de settings
   * Pourquoi : Toggle simple sans gestion d'état complexe
   */
  toggleSettings() {
    const mountPoint = document.getElementById("settings-dropdown-mount");
    
    // Si déjà ouvert, ne rien faire (le backdrop fermera)
    if (this.settingsDropdown) {
      return;
    }

    // Créer et monter le dropdown
    this.settingsDropdown = new SettingsDropdown();
    this.settingsDropdown.mount(mountPoint);

    // Observer la suppression du dropdown pour reset la référence
    const observer = new MutationObserver(() => {
      if (!document.querySelector(".settings-dropdown-container")) {
        this.settingsDropdown = null;
        observer.disconnect();
      }
    });

    observer.observe(mountPoint, { childList: true });
  }
}

export default AppHeader;
